import React from "react";
import {Box, Typography} from "@mui/material";
import {ClosePopupBtn} from "../../../com/closePopupBtn/closePopupBtn";

interface Props {
    onClose: VoidFunction;
    headerCaption: string;
    //header bg
    bg?: string;
    //justifyContent
    jc?: string;
    classForHeader?: string;
}

export const PopupHeader: React.FC<Props> = ({
                                                 onClose,
                                                 headerCaption,
                                                 bg = "#014780",
                                                 jc = "center",
                                                 classForHeader = "",
                                             }) => {
    return (
        <Box sx={{
            position: "relative",
        }}>
            <Box
                className={classForHeader}
                sx={{
                    position: "relative",
                    display: "flex",
                    height: "40px",
                    background: bg,
                    alignItems: "center",
                    justifyContent: jc,
                    padding: "0 20px",
                    cursor: classForHeader !== "" ? "move" : "default"
                }}>
                <Typography color={"#ffffff"} fontWeight={700}>
                    {headerCaption}
                </Typography>
            </Box>
            <Box sx={{
                display: `flex`,
                justifyContent: `flex-end`,
                position: "absolute",
                right: "6px",
                top: "6px"
            }}>
                <ClosePopupBtn onClose={onClose}/>
            </Box>
        </Box>

    )
}